import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE, BLACK } from '@/constants/colors';

export const Container = styled.div`
  .channel-page {
    &__hero {
      padding-top: 40px;
      padding-bottom: 40px;
      min-height: 350px;
      position: relative;
    }

    &__swimlanes {
      padding-top: 45px;
      padding-bottom: 45px;
    }

    &__collection {
      &:not(:first-of-type) {
        padding-top: 20px;
      }
      &:not(:last-of-type) {
        padding-bottom: 20px;
      }
    }
  }

  .hero {
    &__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${WHITE};
      border-radius: 12px;
      box-shadow: 0 10px 25px ${rgba(BLACK, 0.06)};
      max-height: 340px;
      height: 100%;
      padding: 15px;

      img {
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }

    &__description {
      word-break: break-word;
    }

    &__zipcode {
      margin-top: 24px;
      max-width: 540px;
    }
  }

  .zipcode {
    .zipcode__input-label {
      font-size: 1.6rem;
      line-height: 1.6rem;
      font-weight: 600;
      margin-bottom: 12px;
    }
  }
`;

export default Container;
